import { serialize } from 'cookie'

const ONE_HOUR = 60 * 60
const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'

const getResetTokenCookieOptions = (shouldDelete = false) => ({
    path: '/',
    httpOnly: true,
    secure: !IS_DEVELOPMENT,
    maxAge: shouldDelete ? new Date(0) : ONE_HOUR,
})

export const createResetTokenHttpCookie = (resetToken, response) => {
    response.setHeader(
        'Set-Cookie',
        // @ts-ignore
        serialize('resetToken', resetToken, getResetTokenCookieOptions()),
    )
}

export const deleteResetTokenCookie = response => {
    response.setHeader(
        'Set-Cookie',
        serialize(
            'resetToken',
            '',
            // @ts-ignore
            getResetTokenCookieOptions(true),
        ),
    )
}
